import { TypographyBase, GTypographyLinkBase } from './variants';

import type { ITypography } from './variants/types';

/**
 * @deprecated Use the appropriate element (h1, p, div, etc.) directly.
 * Utility classes for styling are in `shared/styles/_typography.scss`.
 * 
 * The HTML tag is set using the "forwardedAs" prop on the parent component.
 * @source https://styled-components.com/docs/api#forwardedas-prop
 */

const Typography = ({ to = '', tabIndex = 0, openInNewTab = false,  ...props }: ITypography) => {
  if (Boolean(to)) {
    return  <GTypographyLinkBase to={to} target={openInNewTab ? '_blank' : '_self'}  tabIndex={tabIndex} {...props} />;
  }
  return <TypographyBase {...props} />;
};

export default Typography;
